<template>
    <div>
        <Row :gutter="16" style="margin-bottom: 40px;">
            <div class="w-full flex justify-end">
                <i-select v-model="modulo" clearable @on-change="getFuncao(modulo)" placeholder="Modulo" class="w-64 ml-2">
                    <Option v-for="item in modulos" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <i-select v-model="funcao" v-if="modulo!=null" clearable @on-change="getFuncionalidade(funcao)" placeholder="Função" class="w-64 ml-2">
                    <Option v-for="item in funcoes" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <i-select v-model="funcionalidade" v-if="funcao!=null && modulo!=null" clearable @on-change="filtrarDados" placeholder="Funcionalidade" class="w-64 ml-2">
                    <Option v-for="item in funcionalidades" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <i-select v-model="analista" clearable @on-change="filtrarDados" placeholder="Analista" class="w-64 ml-2">
                    <Option v-for="item in analistas" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                 <InputNumber @input="carregarDados" :active-change="false" :min="1" v-model="periodo"></InputNumber>
                <i-switch @on-change="carregarDados" false-value="mensal" size="large" class="m-2"
                            true-value="semanal" v-model="formato">
                    <span slot="open">SEM</span>
                    <span slot="close">MEN</span>
                </i-switch>
            </div>
        </Row>
        <bar-chart
            v-if="mostrar_grafico"
            :options="dados_grafico"
            @click="carregarTabela"
        />
        <Spin size="large" fix v-if="carregar"></Spin>
        <tickets-table :csv="csv" :analistas="analistas" :loading="carregar_tabela"
                    :tickets="tickets" 
                    ocultarRelatores ocultarCadastros 
                    ocultarObservacao ocultarFinalizados 
                    exibirCriticidade exibirDetalhes 
                    exibirReaberto    
                    v-if="mostrar_tabela"></tickets-table> 
    </div>
</template>

<script>
    const {moment} = require("../../../helpers/utils.js")
    import accounting from "accounting"
    export default {
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
        },
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        data:()=>({
            periodo: 6,
            formato: 'semanal',
            analista: null,
            modulo:null,
            modulos:[],
            funcao:null,
            funcoes:[],
            funcionalidade:null,
            funcionalidades:[],
            bug:[],
            melhoria:[],
            ss:[],
            mvp:[],
            dados: [],
            dados_grafico: {},
            mostrar_grafico:true,
            carregar: false,
            mostrar_tabela: false,
            carregar_tabela: false,
            tickets:[],
            csv:false,
            legenda:null,
        }),
        computed: {
            analistas() {
                return this.$store.getters['analistas']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }))
            },
        },
        methods: {
            async carregarDados() {
                this.carregar = true
                const URI = `ticket/estatisticas/reabertos?formato=${this.formato}&periodo=${this.periodo}`
                const {data} = await this.$axios.get(URI)
                this.dados = data.reverse()
                this.legenda = this.caregarLegenda(data.length)
                this.filtrarDados()
                this.carregar = false
            },
            filtrarDados() {
                // filtro para pegar somente tickets que o programador iniciou o desenvolvimento
                let dados = this.dados
                this.mostrarDados([
                    dados.map((item) => this.getFilter(this.filtrarTipo(item,32))),
                    dados.map((item) => this.getFilter(this.filtrarTipo(item,33))),
                    dados.map((item) => this.getFilter(this.filtrarTipo(item,35))),
                    dados.map((item) => this.getFilter(this.filtrarTipo(item,45))),
                ])
            },
            filtrarTipo(dados,prazo) {
                // filtro para bug
                if (prazo == 32){
                    dados = dados.filter(item => {
                        if (item.tipo_id == 32) {
                            return item
                        }
                    })  
                    return dados  
                } else {
                    // filtro para melhoria
                    if (prazo == 33){
                        dados = dados.filter(item => {
                            if (item.tipo_id == 33) {
                                return item
                            }
                        })  
                        return dados  
                    } else {
                        // filtro para solicitação de serviço
                        if (prazo == 35){
                            dados = dados.filter(item => {
                                if (item.tipo_id == 35) {
                                    return item
                                }
                            })  
                            return dados  
                        } else {
                                // filtro para story
                            if (prazo == 45){
                                dados = dados.filter(item => {
                                    if (item.tipo_id == 45) {
                                        return item
                                    }
                                })  
                                return dados  
                            }
                        }
                    }
                }   
            },
            getFilter(dados){
                const analista = this.analista
                const modulo = this.modulo
                const funcao = this.funcao
                const funcionalidade = this.funcionalidade
                return dados.filter((item) => {
                    // verifica os filtros ativos
                    if (analista && modulo && funcao && funcionalidade) {
                        return analista == item.atribuido_a_id && modulo == item.modulo && funcao == item.funcao && funcionalidade == item.funcionalidade
                    }
                    if (analista && modulo && funcao) {
                        return analista == item.atribuido_a_id && modulo == item.modulo && funcao == item.funcao
                    }
                    if (analista && modulo) {
                        return analista == item.atribuido_a_id && modulo == item.modulo
                    }
                    if (analista) {
                        return analista == item.atribuido_a_id
                    }
                    if (modulo && funcao && funcionalidade) {
                        return modulo == item.modulo && funcao == item.funcao && funcionalidade == item.funcionalidade
                    }
                    if (modulo && funcao) {
                        return modulo == item.modulo && funcao == item.funcao
                    }
                    if (modulo) {
                        return modulo == item.modulo
                    }
                    return item
                })   
            },
            carregarTabela(params) {
                if (params.selected==false){
                    this.mostrar_tabela = true
                    this.carregar_tabela = true
                    // filtro para bug
                    if (params.seriesIndex == 0) {
                        this.tickets = this.bug[params.dataIndex]
                    } else {
                        // filtro para melhoria
                        if (params.seriesIndex == 1) {
                            this.tickets = this.melhoria[params.dataIndex]
                        } else {
                            // filtro para solicitação de serviço
                            if (params.seriesIndex == 2) {
                                this.tickets = this.ss[params.dataIndex]
                            } else {
                                // filtro para story
                                if (params.seriesIndex == 4) {
                                        this.tickets = this.mvp[params.dataIndex]
                                } else {
                                    if (params.seriesIndex == 5){
                                        this.tickets = this.dados[params.dataIndex]
                                    }
                                }
                            }
                        }
                    }
                    this.carregar_tabela = false
                } else {
                    this.mostrar_tabela = false;
                }
            },
            mostrarDados([bug,melhoria,ss,mvp]){
                const dados = this.dados.map((item) => this.getFilter(item)) 
                this.bug = bug
                this.melhoria = melhoria
                this.ss = ss
                this.mvp = mvp
                const totais = dados.map((value) => ({
                                value: value.length || 0,
                                itemStyle: {
                                    barBorderColor: '#FF1744',
                                }
                            }))
                this.dados_grafico = {
                    tooltip: {},
                    legend: {},
                    xAxis: {
                        data: this.legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    label: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value || '',
                    },
                    series: [
                        {
                            name: 'Bugs',
                            type: 'bar',
                            color: '#FF1744',
                            data: bug.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#FF1744',
                                }
                            })),
                        },
                        {
                            name: 'Melhorias',
                            type: 'bar',
                            color: '#FFDF20',
                            data: melhoria.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#FFDF20',
                                }
                            })),
                        },
                        {
                            name: 'SS',
                            type: 'bar',
                            color: '#2196F3',
                            data: ss.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#2196F3',
                                }
                            })),
                        },
                        {
                            name: 'MVP',
                            type: 'bar',
                            color: '#3F51B5',
                            data: melhoria.map((value) => ({
                                value: value.length || '',
                                itemStyle: {
                                    barBorderColor: '#3F51B5',
                                }
                            })),
                        },
                        {
                            name: 'Totais',
                            type: 'line',
                            color: '#263238',
                            data: totais,
                        }
                    ]
                }
            },
            caregarLegenda(size) {
                let legenda = []
                if (this.formato === "semanal") {
                    legenda = ["Esta sem.", "1 sem. atrás"]
                    for (let i = 2; i < size; i++) {
                        legenda[i] = `${i} sem. atrás`
                    }
                } else {
                    for (let i = 0; i < size; i++) {
                        legenda[i] = moment().subtract(i, 'months').format("MMMM/YY")
                    }
                }
                return legenda.reverse()
            },
            async getModulos(){
                let modulos = await this.getChildren(1)
                this.modulos = _.orderBy(modulos, ['label'],['asc'])
            },

            async getFuncao(id){
                let funcoes = await this.getChildren(id)
                this.funcoes = _.orderBy(funcoes, ['label'],['asc'])
                this.filtrarDados()
            },

            async getFuncionalidade(id){
                let funcionalidades = await this.getChildren(id)
                this.funcionalidades = _.orderBy(funcionalidades, ['label'],['asc'])
                this.filtrarDados()
            },

            async getChildren(id) {
                if (!id) return [];
                const {data: children} = await this.$axios.get(`tree/${id}/children`);
                return children.map(item => ({
                    value: item.id,
                    label: item.nome
                }));
            },
        },
        created() {
            this.getModulos()
            this.carregarDados()
        },
        watch: {
            refresh(){
                if (this.refresh){
                    this.formato = 'semanal'
                    this.periodo = 6
                    this.mostrar_tabela = false
                    this.carregarDados()
                }
            },
            download(){
                this.csv=this.download
            },
            close(){
                if (this.close){
                    this.mostrar_tabela = false
                    this.mostrar_grafico = false
                } else {
                    this.mostrar_grafico = true
                }    
            },
            status(){
                this.filtrarDados()
                this.mostrar_tabela = false
            },
            mostrar_tabela(){
                this.$emit('download',this.mostrar_tabela)
            }
        }
}
</script>
